


export const chartTooltipRenderer = (params) => {
  let title = ""
  let label = ""
  let value = ""
  // console.log(params)
  if (params && params.datum) {
    let xv = params.datum[params.xKey]
    xv = (typeof xv === "number" ? xv : 0)

    let yv = params.datum[params.yKey]
    // some bug in charts sends us a key that has no value?
    // so sometimes this ends up as null, so we have to check and ensure yv is a number
    // or toFixed will fail
    yv = (typeof yv === "number" ? yv : 0)

    //console.log(params.datum)
    let fages = Object.fromEntries(Object.entries(params.datum).filter(([k, v]) => k.startsWith("Ages.")))
    //console.log(fages)
    let ages = ""
    for (const p in fages) {
      if (ages.length > 0) {
        ages += ", "
      }
      ages += fages[p]
    }
    let year = ""
    let yearD = params.datum["year"]
    year = (typeof yearD === "number" ? yearD : 0)
    if (ages.length === 0) {
      ages = xv
    }

    label = year + ": " + ages
    value = yv.toFixed(0);
    let spl = params.yName.split("##");
    title = spl[0]

  }


  let r = {
    heading: label.toString(),
    title: title,
    data: [{
      label: label.toString(),
      value: value.toString(),
    }]
  };
  // console.log(r)
  return r
};


export const chartTooltipRendererMoney = (params) => {
  let r = chartTooltipRenderer(params)
  // console.log(r)

  let v =
    Number(Number(r.data[0].value).toFixed(0)).toLocaleString("en-CA", {
      style: "currency",
      currency: "CAD",
      maximumFractionDigits: 0,
      // maximumFractionDigits: 1,
      // minimumractionDigits: 1,
      // notation: "compact",
    });
  r.title += "     " + v
  // r.data[0].value = v
  r.data = []
  // console.log(r)
  return r
};


export const chartTooltipRendererPercent = (params) => {
  // we can leave this as the default
  //return

  let r = chartTooltipRenderer(params)
  let v = ""
  if (params && params.datum) {
    let yv = params.datum[params.yKey]
    yv = (typeof yv === "number" ? yv : 0)
    v = Number(yv.toFixed(2)) + "%";
  }
  r.title += "     " + v
  // r.data[0].value = v
  r.data = []
  return r
};
